import React, { useEffect, useState } from 'react'
import { Input, Table, Typography, Select, Button, Badge, Drawer, Checkbox, Divider, Row, Col, Space, Form } from 'antd'
import { getAllLeads } from '../services/httpCalls'
import { DateConvert } from "../utils/dateConverter";
import { useSetRecoilState } from 'recoil'
import { showloader } from "../store/gloabalState";
import useNotify from '../utils/useNotify';
const Leads = () => {
    const { Option } = Select
    const [searchByType, setSearchByType] = useState("PAN")
    const setShowLoader = useSetRecoilState(showloader);
    const [leads, setLeads] = useState([])
    const notify = useNotify()
    const colsOrg = [{
        title: "User Name",
        key: "name",
        width: "200px",
        align: "center",
        render: (val, record) => {
            let key = Object.keys(record).join('')
            return <p key={record[key]?.creationDate}>{record[key]?.fullName ? record[key]?.fullName : "-"}</p>
        }

    },
    {
        title: "Email",
        dataIndex: "email",
        key: "email",
        align: "center",
        render: (val, record) => {
            let key = Object.keys(record).join('')
            return <p key={record[key]?.creationDate}>{record[key]?.emailId ? record[key]?.emailId : "-"}</p>
        }
    },
    {
        title: "Phone Number",
        dataIndex: "phoneNumber",
        key: "phoneNumber",
        align: "center",
        render: (val, record) => {
            let key = Object.keys(record).join('')
            return <p key={record[key]?.creationDate}>{record[key]?.phoneNumber ? record[key]?.phoneNumber : "-"}</p>
        }
    },
    {
        title: "Company Type",
        dataIndex: "companyType",
        key: "companyType",
        align: "center",
        render: (val, record) => {
            let key = Object.keys(record).join('')
            return <p key={record[key]?.creationDate}>{record[key]?.companyType ? record[key]?.companyType : "-"}</p>
        }
    },
    {
        title: "PAN",
        key: "pan",
        align: "center",
        render: (val, record) => {
            let key = Object.keys(record).join('')
            return <p key={record[key]?.creationDate}>{record[key]?.companyPan ? record[key]?.companyPan : "-"}</p>
        }
    },
    {
        title: "Creation Date",
        dataIndex: "creation",
        key: "creation",
        align: "center",
        width: "160px",
        render: (val, record) => {
            let key = Object.keys(record).join('')
            return <p key={record[key]?.creationDate}>{record[key]?.creationDate ? DateConvert(record[key]?.creationDate) : "-"}</p>
        }
    },
    {
        title: "Designation",
        dataIndex: "designation",
        key: "designation",
        align: "center",
        render: (val, record) => {
            let key = Object.keys(record).join('')
            return <p key={record[key]?.creationDate}>{record[key]?.signUpUserRole ? record[key]?.signUpUserRole?.replaceAll('_', " ") : "-"}</p>
        }
    },


    ]
    const selectAfter = (
        <Select defaultValue={searchByType} style={{
            width: "140px",
        }} onChange={(e) => setSearchByType(e)} >
            <Option value="PAN">PAN</Option>
            <Option value="GST Number">GST Number</Option>
            <Option value="Company Name">Company Name</Option>
        </Select>
    );

    const getLeads = () => {
        setShowLoader(true)
        getAllLeads().then((res) => {
            setLeads(res)
        }).catch((err) => {
            notify.error("Not able to fetch leads")
        }).finally(() => setShowLoader(false))
    }
    useEffect(() => {
        getLeads()
    }, [])
    return (
        <div>
            <div className="leads_heading">
                <Typography.Title level={2}>Leads</Typography.Title>
            </div>
            {/* <div className="search-box_leads" style={{
                margin: "10px 0 20px 0"
            }}>
                <Input style={{
                    width: "500px",
                    margin: "0 10px"

                }} addonAfter={selectAfter} onChange={(e) => console.log(e.target.value)} placeholder='Search by PAN,GST,Company Name'
                />
                <Button type='primary'>Search</Button>
            </div> */}
            <div className="org_table">
                <Table columns={colsOrg} className='styledAntd' dataSource={leads}
                    pagination={{
                        pageSize: 10,
                        showSizeChanger: false,
                        position: ["bottomCenter"],
                    }}
                    rowKey={(record) => {
                        let key = Object.keys(record).join('')
                        return record[key]?.creationDate
                    }}

                />
            </div>
        </div>
    )
}

export default Leads
